import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { colors } from '../styles/colors'

export type ProgressProps = {
  percentage: number
  color?: string
  backgroundColor?: string
  height?: number
  borderRadius?: number
}

export const Progress: FC<ProgressProps> = ({
  percentage,
  color = colors.primary,
  backgroundColor = colors.grey300,
  height = 4,
  borderRadius = 2,
}) => {
  const clampedPercentage = Math.max(0, Math.min(100, percentage))

  return (
    <ProgressContainer
      $backgroundColor={backgroundColor}
      $height={height}
      $borderRadius={borderRadius}
    >
      <ProgressBar
        $color={color}
        $percentage={clampedPercentage}
        $height={height}
        $borderRadius={borderRadius}
      />
    </ProgressContainer>
  )
}

const ProgressContainer = styled.div<{
  $backgroundColor: string
  $height: number
  $borderRadius: number
}>`
  width: 100%;
  height: ${props => `${props.$height}px`};
  background-color: ${props => props.$backgroundColor};
  border-radius: ${props => props.$borderRadius}px;
  overflow: hidden;
`

const ProgressBar = styled.div<{
  $color: string
  $percentage: number
  $height: number
  $borderRadius: number
}>`
  height: ${props => props.$height}px;
  width: ${props => `${props.$percentage}%`};
  background-color: ${props => props.$color};
  border-radius: ${props => props.$borderRadius}px;
  transition: width 0.3s ease-in-out;
`
